<template>
  <el-container v-page-title="course.name" v-loading="loading">
    <page-nav :pageNavObj="pageNavObj"></page-nav>
    <el-card class="box-card">
      <div slot="header">
        <el-row>
          <el-col :span="7">
            <div>
              <el-image v-if="course.image !== undefined" :src="course.imageUrl" style="width: 293px;height: 220px;"></el-image>
            </div>
          </el-col>
          <el-col :span="17">
            <div style="padding: 0 15px">
              <div style="height: 180px">
                <div class="course-tile">
                  {{course.name}}
                  <span class="red" v-if="!isHaveCourse">（非本学习班课程）</span>
                </div>
                <p>
                  {{course.shortDesc}}
                </p>
              </div>
              <div>
                <el-row type="flex" align="middle">
                  <el-col :span="16">
                    <el-tag class="tag-margin-right">{{course.teacherDto.name}} 老师</el-tag>
                    <el-tag class="tag-margin-right">{{course.hours }} 学时</el-tag>
                  </el-col>
                  <!-- 当userCourseProcess 不为null,说明已经购买了课程-->
                  <!--<el-col :span="4">-->
                  <!--  <span class="font-price" v-if="course.userCourseProcess === null">￥ {{course.price}}</span>-->
                  <!--</el-col>-->
                  <el-col :span="4">
                    <div class="study-process">
                      <!--<el-row type="flex" align="middle" justify="end" v-if="course.userCourseProcess !== null">-->
                      <!--  <el-col :span="6"><i class="el-icon-s-management el-icon&#45;&#45;left"></i>已学：</el-col>-->
                      <!--  <el-col :span="13"><el-progress :stroke-width=9 :percentage="course.userCourseProcess"></el-progress></el-col>-->
                      <!--</el-row>-->
                      <el-row v-if="isHaveCourse" type="flex" align="middle" justify="end">
                        <el-col :span="6"><i class="el-icon-s-management el-icon--left"></i>已学：</el-col>
                        <el-col :span="13"><el-progress :stroke-width=9 :percentage="course.userCourseProcess || 0"></el-progress></el-col>
                      </el-row>
                    </div>
                    <!--<el-button type="primary" @click="toOrder" round v-if="course.userCourseProcess === null">立即购买</el-button>-->
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 15px"></div>
    </el-card>
    <!--课程tab-->
    <course-tab :isHaveCourse="isHaveCourse" :courseId="course.id" :course="course"></course-tab>
    <!--推荐课程-->
    <recommend-course  course-type="C"></recommend-course>
  </el-container>
</template>

<script>
  const PageNav = () => import('@/components/course/PageNav');
  const RecommendCourse = () => import('@/components/course/RecommendCourse');
  const CourseTab = () => import('@/components/course/CourseTab');
  export default {
    name: "detail",
    components: {
      PageNav,
      RecommendCourse,
      CourseTab
    },
    data() {
      return {
        course: {
          teacherDto: {}
        },
        pageNavObj: {}, // 页面导航对象
        studyProcess: 0,
        loading: false,
        isHaveCourse: true
      }
    },
    methods: {
      //查询用户该课程的订单号
      // async queryCourseOrderId(courseId){
      //   const {content} = await this.$http.get('/business/web/order/queryOrderStatus',{params:{courseId:courseId}});
      //   if (content){
      //     this.queryOrderStatus(content);
      //   }
      // },
      // 判断是否拥有该课程
      async isHave(courseId){
        const { content } = await this.$http.get('/business/web/userCourse/isBuyCourse', {params:{courseId}});
        this.isHaveCourse = content;
      },
      async queryOrderStatus(orderId){
        const { content } = await this.$http.get('/business/web/order/isPay',{params:{orderId:orderId}});
        if (content){
          const params = {
            id: orderId,
            userId: this.$store.state.userInfo.id,
            courseId: this.$route.params.courseId,
            paidType: 'W',
            serialNumber: '123'
          };
          await this.$http.post('/business/web/order/completeOrder', params);
          await this.queryByCourseId(this.$route.params.courseId);
        }
      },
      handleClick(tab, event) {
      },
      toOrder() {
        // 未登录不跳转至订单页面
        if (!this.$store.state.userInfo){
          this.$message.error("抱歉,您还未登录 !");
          this.$router.push({ path: '/login' });
          return
        }
        // 发起请求创建订单
        const params = {
          courseId: this.course.id
        };
        let routerName = 'OrderConfirm';
        let routeUrl = this.$router.resolve({ name: routerName, params: params });
        window.open(routeUrl.href, '_blank');
      },
      toResource() {
        let sectionDto = this.course.chapterDtos[0].sectionDtos[0];
        let resolveRouter = null;
        if (sectionDto.targetType === 'V') {
          resolveRouter = this.$router.resolve({ path: `/home/eduVideoTest/${this.course.id}/${sectionDto.id}`});
        }else if (sectionDto.targetType === 'D') {
          resolveRouter = this.$router.resolve({ path: `/home/eduDoc/${this.course.id}/${sectionDto.id}`});
        }
        if (resolveRouter) {
          window.open(resolveRouter.href,'_blank')
        }
      },
      async queryByCourseId(courseId) {
        this.loading = true;
        const {content} = await this.$http.get('/business/web/course/queryById',{params:{courseId:courseId}});
        this.course = content;
        this.loading = false;

        this.initPageNavObj();
      },
      initPageNavObj() {
        this.pageNavObj = {
          courseType: this.course.courseType,
          courseId: this.course.id,
          courseName: this.course.name,
        }
      }
    },
    mounted() {
      let courseId = this.$route.params.courseId;
      // this.queryCourseOrderId(courseId);
      this.queryByCourseId(courseId);
      this.isHave(courseId)
    }
  }
</script>

<style scoped>
  .red {
    color: #F56C6C;
  }
  .el-container {
    width: 1100px;
    min-width: 1100px;
    margin: 35px auto 0 auto;
  }
  .box-card {
    width: 100%;
    border: 0px;
  }
  .course-tile {
     font-size: 24px;
     font-weight: 600;
     color: #333;
   }
  .font-price {
    font-size: 25px;
    color: #f01414;
  }
  .tag-margin-right {
    margin-right: 8px;
  }
  .study-process {
    position:absolute;
    width: 300px;
    top: 5px;
    right: 10px;
  }
</style>
